import { ElementType, Template, GlobalConfig } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const createTemplate2MobileNavigationPopup = (
  globalConfig: GlobalConfig
): Template => ({
  id: "mobile-navigation",
  name: "Mobile Navigation",
  industry: "template2",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "#2D2D2D",
        borderRadius: "0",
        padding: "48px 16px 32px 16px",
        margin: "0",
        width: "100%",
        height: "100vh",
        // position: "fixed",
        top: "0",
        left: "0",
        display: "flex",
        flexDirection: "column",
      },
      children: [
        // Close button (X) in top-right
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            position: "absolute",
            top: "16px",
            right: "16px",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            overflow: "hidden",
          },
          interactions: {
            onClick: {
              type: "hideElement",
              targetId: "popup-mobile-navigation",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "✕",
              styles: {
                fontSize: "24px",
                fontWeight: "400",
                color: "#FFFFFF",
                margin: "0",
                fontFamily: "Poppins, sans-serif",
              },
            },
          ],
        },
        // Navigation links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "start",
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "55px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Ingredients",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Why it works?",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundColor: "#FFB214",
                color: "#000000",
                padding: "27px 0px",
                borderRadius: "100px",
                fontWeight: "600",
                fontSize: "20px",
                border: "none",
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
                marginTop: "20px",
                width: "100%",
                maxWidth: "400px",
                boxShadow: "0px 0px 24px 0px rgba(255, 255, 255, 0.6) inset",
              },
              interactions: {
                onClick: {
                  type: "hideElement",
                  targetId: "popup-mobile-navigation",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});
